import { Link } from "react-router-dom";

export function ProjectCard({ project, index }) {
  return (
    <Link
      to={`/projects/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className="group grid grid-cols-1 lg:grid-cols-12 gap-8 items-center bg-white p-6 sm:p-8 border border-[#12281a]/10 hover:border-[#b38b47]/50 transition-colors"
    >
      <div className="lg:col-span-4 aspect-[16/10] relative overflow-hidden bg-[#12281a]">
        {project.image ? (
          <img
            src={project.image}
            alt={`${project.name}, ${project.location}`}
            className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
            loading={index === 0 ? "eager" : "lazy"}
          />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-[#12281a] to-[#254631] flex items-center justify-center">
            <span className="font-monument text-[#b38b47] text-lg tracking-widest text-center px-6">
              {project.name
                .split(" ")
                .map((w) => w[0])
                .join("")}
              <span className="block text-[10px] tracking-[0.3em] text-[#f7f5f0]/60 mt-2">
                PHOTOGRAPH TO BE ADDED
              </span>
            </span>
          </div>
        )}
        <span className="absolute top-3 left-3 bg-[#12281a]/95 text-[#f7f5f0] text-[10px] px-2 py-1 uppercase tracking-wider">
          {project.status}
        </span>
      </div>

      <div className="lg:col-span-8">
        <span className="text-xs uppercase tracking-wider text-[#b38b47] font-semibold">{project.type}</span>
        <h3 className="text-2xl font-monument text-[#12281a] mt-1 mb-2 group-hover:text-[#b38b47] transition-colors">
          {project.name}
        </h3>
        <p className="text-xs text-[#12281a]/60 mb-4">
          {project.location} · {project.developer}
        </p>
        <p className="text-sm text-[#2c382f]/80 leading-relaxed mb-4">{project.tagline}</p>
        <span className="text-xs text-[#12281a] font-semibold uppercase tracking-wider">
          View Project →
        </span>
      </div>
    </Link>
  );
}
